export default __webpack_public_path__ + "static/media/Page-4.7c942fdc.svg";